const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
const AUTH_BASE_URL = process.env.NEXT_PUBLIC_AUTH_API_URL;
const SURVEY_BASE_URL = process.env.NEXT_PUBLIC_SURVEY_API_URL;
const CORE_BASE_URL = process.env.NEXT_PUBLIC_CORE_API_URL;
const SOURCING_BASE_URL = process.env.NEXT_PUBLIC_SOURCING_API_URL;
const PRODUCTS_BASE_URL = process.env.NEXT_PUBLIC_PRODUCTS_API_URL;
const LOAN_APP_BASE_URL = process.env.NEXT_PUBLIC_LOAN_APP_API_URL;
const FFM_BASE_URL = process.env.NEXT_PUBLIC_FFM_URL;
const HRMS_BASE_URL = process.env.NEXT_PUBLIC_HRMS_API_URL;
const ACCOUNTING_BASE_URL = process.env.NEXT_PUBLIC_ACCOUNTING_API_URL;
const ApiRoutes = {
  verify_user: '/account/verify_user',
  whoami: '/account/whoami',
  logoff: '/account/logoff',
  employee_branch: '/branch/employee_branch',
  branch_filter: '/utils/party_geo_childs',
  assign_branch: '/branch/pop_assign_branch',
  branch_list: '/branch/pop_node_list',
  list_security_group: '/security_management/list_security_group',
  security_management_permissions_list: '/security_management/list_permissions',
  associate_security_grp_permissions: '/security_management/associate_security_group_permission',
  add_security_group: '/security_management/add_security_group',
  delete_security_group: '/security_management/delete_security_group',
  update_location_party: '/branch/update_location_party',
  get_location_party: '/branch/get_location_party',
  geo_child: '/utils/geo_child',
  add_zcrab: '/branch/add_zcrab',
  branch_list_detail: '/branch/branch_list',
  center_id: '/yancy/api/SuryodayCenterMaster',
  update_employee_posting: '/utils/update_location_data',
  get_employee_posting: '/utils/get_employee_posting',
  delete_employee_posting: '/utils/delete_employee_posting',
  remove_assigned_node: '/branch/remove_employee_assign_node',
  employee_list_lite: '/utils/employee_list_lite',
  organisation_companies: '/common/organisation_companies',
  department_master_list: '/api/masters/department_list',
  hrms_security_group_list: '/simple-api/SecurityGroup',
  
  // HRMS Endpoints
  hrms_department_list: '/hrms/department_list',
  hrms_department_search: '/hrms/department_list',
  hrms_create_department: '/hrms/create_department',
  hrms_update_department: '/hrms/update_department',
  hrms_delete_department: '/hrms/delete_department',
  hrms_get_designations: '/hrms/get_designations',
  hrms_add_update_designation: '/hrms/add_update_designation',
  hrms_employee_position_type: '/yancy/api/EmplPositionType',
  hrms_employee_list: '/hrms/employee_list_action',
  hrms_employee_list_lite: '/hrms/employee_list_lite',
  hrms_add_employee: '/hrms/add_employee_action',
  hrms_update_employee: '/admin/update_employee_action',
  hrms_delete_employee: '/hrms/delete_employee',
  hrms_branch_list: '/hrms/branch_list',
  hrms_locality_search: '/geo/list_locality',
  hrms_state_list: '/geo/list_state',
  hrms_geo_child: '/utils/geo_child',
  hrms_reset_employee_password: '/hrms/reset_empl_password',
  hrms_activate_account: '/hrms/activate_account',
  hrms_role_type: '/yancy/api/RoleType',
  hrms_emp_org_unit_assignments: '/hrms/emp_org_unit_assignments',
  hrms_get_emp_org_units: '/hrms/get_emp_org_units',
  hrms_deassociate_emp_org_unit: '/hrms/deassociate_emp_org_unit',
  hrms_user_login_security_group: '/simple-api/UserLoginSecurityGroup',
  hrms_add_employee_security_group: '/hrms/assign_user_security_grp',
  hrms_delete_employee_security_group: '/security_management/delete_security_group',

  get_division_nomenclature: '/hrms/org_div/get_division_nomenclature',
  hrms_org_division_list: '/hrms/org_div/org_division_list',
  hrms_org_div_geo_mapping: '/hrms/org_div/geo_mapping',
  hrms_org_div_get_geo_mapping: '/hrms/org_div/get_geo_mapping',
  hrms_org_div_dissociate_geo_mapping: '/hrms/org_div/dissociate_geo_mapping',
  hrms_employee_geo_mapping: '/hrms/employee_geo_mapping',
  hrms_get_geo_mapping: '/hrms/get_emp_geo_mapping',
  hrms_dissociate_geo_mapping: '/hrms/dissociate_emp_geo_mapping',
  hrms_add_edit_emp_routing_plans: '/hrms/add_edit_emp_routing_plans',
  hrms_employee_routing_plans: '/hrms/employee_routing_plans',
  hrms_deassociate_route_plan: '/hrms/deassociate_route_plan',
  hrms_org_div_branch_list: '/hrms/org_div/branch_list',
  hrms_org_div_branches: '/hrms/org_div/branches',
  hrms_org_div_all_org_divisions: '/hrms/org_div/all_org_divisions',
  add_update_levels: '/hrms/org_div/add_or_update_division_nomenclature',
  download_div_nom_sample_excel: '/hrms/org_div/download_org_division',
  upload_org_div: '/hrms/org_div/upload_org_div',

  login: '/auth/login',

  // Survey Endpoints
  survey_list: '/survey/list_survey',
  survey_get: '/survey/get_survey',
  survey_field_updates: '/survey/field_survey_updates',
  survey_form_questions: '/survey/get_survey_form_question',
  survey_question_categories: '/survey/get_survey_question_category',
  survey_question_types: '/survey/get_survey_question_type',
  survey_add_form_question: '/survey/add_survey_form_question',
  survey_update_form_question: '/survey/update_form_question',
  survey_delete_form_question: '/survey/delete_survey_form_question',
  survey_delete_question_option: '/survey/delete_question_option',
  survey_get_survey_form: '/survey/get_survey_form',
  survey_create_survey_form: '/survey/create_survey_form',
  survey_update_survey_form: '/survey/update_survey_form',
  survey_delete_survey_form: '/survey/delete_survey_form',
  survey_get_form_details: '/survey/get_form_details',
  survey_disassociate_form_question: '/survey/diassociate_form_question',
  survey_update_fq_sequence: '/survey/update_fq_sequence',
  survey_associate_form_question: '/survey/associate_from_question',
  survey_question_required_toggle: '/survey/question_required_toggle',
  survey_duplicate_question: '/survey/duplicate_question',
  survey_duplicate_form: '/survey/duplicate_form',
  survey_save_answers: '/survey/save_answers',
  survey_response_list: '/survey/survey_response_list',
  survey_response_details: '/survey/survey_response_details',

  // Content Management Endpoints
  content_list: '/content/content_listing',
  content_add: '/content/add_content_action',
  content_update: '/content/update_content_action',
  content_delete: '/content/delete_content',
  content_purpose_list: '/content/list_content_purpose',
  content_type_childs: '/content/get_content_type_childs',
  content_type_add: '/content/add_content_type',
  content_type_update: '/content/update_content_type',
  content_type_delete: '/content/delete_content_type',

  // Core Endpoints
  geo_data_via_pincode: '/geo/geo_data_via_pincode',
  geo_childs: '/geo/geo_childs',
  state_geo_childs: '/geo/state_geo_childs',
  geo_boundary: '/geo/geo_boundary',
  geographical_childs_data: '/geo/geographical_childs_data',
  enumeration_list: '/masters/enumeration_list',
  get_enumeration_types: '/masters/get_enumeration_types',
  create_enumeration_type: '/masters/create_enumeration_type',
  update_enumeration_type: '/masters/update_enumeration_type',
  delete_enumeration_type: '/masters/delete_enumeration_type',
  create_enumeration: '/masters/create_enumeration',
  create_enumerations: '/masters/create_enumerations',
  update_enumeration: '/masters/update_enumeration',
  delete_enumeration: '/masters/delete_enumeration',
  get_status_type: '/status/get_status_type',
  create_status_type: '/status/create_status_type',
  update_status_type: '/status/update_status_type',
  delete_status_type: '/status/delete_status_type',
  create_status_item: '/status/create_status_item',
  update_status_item: '/status/update_status_item',
  delete_status_item: '/status/delete_status_item',
  status_item_list: '/masters/status_item_list',
  get_data_sources: '/masters/get_data_sources',
  get_role_type_childs: '/masters/get_role_type_childs',
  list_uom: '/simple-api/list/Uom',

  get_stage: '/stage/get_stage',
  add_stage: '/stage/add_stage',
  update_stage: '/stage/update_stage',
  delete_stage: '/stage/delete_stage',
  get_stage_details: '/stage/get_stage_details',
  assoc_workflow_stages: '/stage/assoc_workflow_stages',
  update_stage_transition_seq_num: '/stage/update_stage_transition_seq_num',
  update_stage_statuses_seq_num: '/stage/update_stage_statuses_seq_num',
  deassociate_workflow_stage_transition: '/stage/deassociate_workflow_stage_transition',
  delete_stage_status: '/stage/delete_stage_status',

  // Sourcing / Lead Endpoints
  get_party: '/party_mgmt/get_party',
  create_party: '/party_mgmt/create_party',
  get_campaigns: '/leads/get_campaigns',
  create_lead: '/leads/create_lead',
  update_lead: '/leads/update_lead',
  lead_list: '/leads/lead_list',
  lead_details: '/leads/lead_details',
  loan_application_list: '/loanapp/get_loan_application',
  loan_application_movement: '/loanapp/get_loan_application_movement',
  loan_application_roles: '/loanapp/get_loan_application_roles',
  loan_application_kyc_details: '/loanapp/loan_application_kyc_details',
  loan_application_cb_details: '/loanapp/cb_details',
  loan_application_loan_details: '/loanapp/loan_details',
  loan_application_documents: '/loanapp/get_application_documents',
  loan_application_agreement_details: '/loanapp/get_appl_agreement_details',
  update_loan_application: '/loanapp/update_loan_application',
  application_stages_timeline: '/loanapp/application_stages_timeline',
  create_application_note: '/loanapp/create_application_note',
  update_application_note: '/loanapp/update_application_note',
  get_application_note: '/loanapp/get_application_note',
  download_application_cam: '/loanapp/download_application_cam',

  // products endpoints
  get_products: '/product/product_listing',
  create_product: '/product/add_product_action',
  get_categories: '/category/category_list_simple',
  get_category_childs: '/category/get_category_childs',
  create_category: '/category/add_category',
  update_category: '/category/update_category',
  delete_category: '/category/delete_category',
  get_prod_cat_feature_cat: '/category/get_prod_cat_feature_cat',
  associate_prod_cat_feature_cat: '/category/associate_prod_cat_feature_cat',
  dissociate_prod_cat_feature_cat: '/category/dissociate_prod_cat_feature_cat',
  update_product_feature_category_appl: '/category/update_product_feature_category_appl',
  associate_product_category_config: '/category/associate_product_category_config',
  associate_product_category_stage: '/category/associate_product_category_stage',
  get_product_category_config: '/category/get_product_category_config',
  dissociate_product_category_config: '/category/dissociate_product_category_config',
  update_product_category_config_value: '/category/update_product_category_config_value',
  update_prod_cat_config_seq_num: '/category/update_prod_cat_config_seq_num',
  associate_product_config: '/product/associate_product_config',
  associate_product_stage: '/product/associate_product_stage',
  get_product_stage: '/product/get_product_stage',
  lookup_all_configs: '/product/lookup_all_configs',
  lookup_all_features: '/product/lookup_all_features',
  get_product_config: '/product/get_product_config',
  find_breadcrumb_path: '/product/find_breadcrumb_path',
  dissociate_product_config: '/product/dissociate_product_config',
  update_product_config_value: '/product/update_product_config_value',
  update_product_config_sequence_num: '/product/update_product_config_sequence_num',
  update_product: '/product/update_product',
  get_feature_categories: '/master/get_feature_categories',
  get_product_feature_types: '/master/get_product_feature_types',
  create_product_feature_type: '/master/create_product_feature_type',
  update_product_feature_type: '/master/update_product_feature_type',
  delete_product_feature_type: '/master/delete_product_feature_type',
  get_product_feature_categories: '/master/get_product_feature_categories',
  create_product_feature_category: '/master/create_product_feature_category',
  update_product_feature_category: '/master/update_product_feature_category',
  delete_product_feature_category: '/master/delete_product_feature_category',
  get_product_features_master: '/master/get_product_features',
  add_product_feature: '/master/add_product_feature',
  update_product_feature: '/master/update_product_feature',
  delete_product_feature: '/master/delete_product_feature',
  get_product_features_by_category: '/master/get_product_features',
  get_product_features: '/product/get_product_features',
  associate_product_features: '/product/associate_product_features',
  associate_product_category_features: '/category/associate_product_category_features',
  duplicate_product: '/product/duplicate_product_action',
  get_segment_group: '/master/get_segment_group',
  create_or_update_segment_group: '/master/create_or_update_segment_group',
  delete_segment_group: '/master/delete_segment_group',
  product_segment_assocs: '/product/product_segment_assocs',
  prodcat_segment_assocs: '/product/prodcat_segment_assocs',
  get_product_segment_groups: '/product/get_product_segment_groups',
  get_prodcat_segment_groups: '/category/get_prodcat_segment_groups',
  get_workflows: '/workflow/get_workflow',
  create_workflow: '/workflow/create_workflow',
  update_workflow: '/workflow/update_workflow',
  delete_workflow_master: '/workflow/delete_workflow_master',
  duplicate_workflow: '/workflow/duplicate_workflow',
  get_workflow_screens: '/workflow/get_workflow_screen',
  create_workflow_screen: '/workflow/create_workflow_screen',
  update_workflow_screen: '/workflow/update_workflow_screen',
  delete_workflow_screen: '/workflow/delete_workflow_screen',
  duplicate_screen: '/workflow/duplicate_screen',
  get_workflow_widgets: '/workflow/get_widget',
  create_workflow_widget: '/workflow/add_widget',
  update_workflow_widget: '/workflow/update_widget',
  delete_workflow_widget: '/workflow/delete_widget',
  get_workflow_fields: '/workflow/get_workflow_field',
  create_workflow_field: '/workflow/create_workflow_field',
  update_workflow_field: '/workflow/update_workflow_field',
  delete_workflow_field: '/workflow/delete_workflow_field',
  upload_workflow_fields: '/workflow/upload_workflow_fields',
  download_field_upload_error_report: '/workflow/download_field_upload_error_report',
  associate_workflow_screen: '/workflow/associate_workflow_screen',
  associate_workflow_screen_field: '/workflow/associate_workflow_screen_field',
  get_workflow_screen_details: '/workflow/get_workflow_screen_details',
  get_workflow_screen_field_details: '/workflow/get_wf_screen_associated_fields',
  get_workflow_details: '/workflow/get_workflow_details',
  get_workflow_screen_assoc: '/workflow/get_workflow_screen_assoc',
  update_workflow_screen_assoc: '/workflow/update_workflow_screen_assoc',
  deassociate_workflow_screen_field: '/workflow/deassociate_workflow_screen_field',
  deassociate_workflow_screen: '/workflow/deassociate_workflow_screen',
  update_screen_field_sequence_num: '/workflow/update_screen_field_sequence_num',
  update_workflow_screen_sequence: '/workflow/update_workflow_screen_sequence',
  update_workflow_field_option_sequence: '/workflow/update_workflow_field_option_sequence',
  delete_workflow_field_options: '/workflow/delete_workflow_field_options',
  update_workflow_screen_field_assoc: '/workflow/update_workflow_screen_field_assoc',
  update_workflow_field_handler: '/workflow/update_workflow_field_handler',
  update_wf_field_handler_sequence_num: '/workflow/update_wf_field_handler_sequence_num',
  deassociate_handler_field_param: '/workflow/deassociate_handler_field_param',
  associate_workflow_category: '/workflow/associate_workflow_category',
  deassociate_workflow_category: '/workflow/deassociate_workflow_category',
  associate_workflow_product: '/workflow/associate_workflow_product',
  deassociate_workflow_product: '/workflow/deassociate_workflow_product',
  find_workflow: '/workflow/find_workflow',
  list_section: '/workflow/list_section',
  add_section: '/workflow/add_section',
  update_section: '/workflow/update_section',
  delete_section: '/workflow/delete_section',
  dissociate_screen_section: '/workflow/dissociate_screen_section',
  associate_workflow_computed_fields: '/workflow/associate_workflow_computed_fields',
  dissociate_workflow_computed_field: '/workflow/dissociate_workflow_computed_field',
  update_workflow_computed_field: '/workflow/update_wf_com_field_default_value',
  get_element_properties: '/workflow/get_element_properties',
  add_element_properties: '/workflow/add_element_properties',
  update_element_property: '/workflow/update_element_property',
  delete_element_property: '/workflow/delete_element_property',
  set_wf_associated_element_props: '/workflow/set_wf_associated_element_props',
  upload_file: '/masters/upload_file',

  // validation class endpoints
  get_validation_class: '/master/get_validation_class',
  create_validation_class: '/master/create_validation_class',
  update_validation_class: '/master/update_validation_class',
  delete_validation_class: '/master/delete_validation_class',
  associate_workflow_field_validation: '/workflow/associate_workflow_field_validation',
  deassociate_workflow_field_validation: '/workflow/deassociate_workflow_field_validation',

  //configurations
  get_config_list: '/config/get_config_key',
  create_config: '/config/create_config_key',
  update_config: '/config/update_config_key',
  delete_config: '/config/delete_config_key',
  get_config_key_categories: '/config/get_config_key_category',
  create_config_key_category: '/config/create_config_key_category',
  update_config_key_category: '/config/update_config_key_category',
  delete_config_key_category: '/config/delete_config_key_category',
  duplicate_config_tree: '/config/duplicate_config_tree',

  // developers endpoints
  bre_validation: '/developer/bre_validation',
  emi_scheduling_engine: '/loanapp/repayment_calculator_engine',

  // BRE management endpoints
  get_bres: '/bre_mgmt/get_bres',
  create_bre_master: '/bre_mgmt/create_bre_master',
  update_bre_master: '/bre_mgmt/update_bre_master',
  associate_bre: '/bre_mgmt/associate_bre',
  bre_details: '/bre_mgmt/bre_details',
  delete_bre_assoc: '/bre_mgmt/delete_bre_assoc',
  delete_bre_master: '/bre_mgmt/delete_bre_master',
  delete_bre_route: '/bre_mgmt/delete_bre_route',
  add_bre_default_route: '/bre_mgmt/add_bre_default_route',
  get_workflow_plantuml: '/bre_mgmt/get_workflow_plantuml',
  run_routing_bres: '/bre_mgmt/run_routing_bres',
  run_validation_bres: '/bre_mgmt/run_screen_bres',
  run_workflow_bres: '/bre_mgmt/run_workflow_bres',
  calculate_computed_field: '/bre_mgmt/calculate_computed_field',
  execute_button_action: '/bre_mgmt/execute_button_action',

  get_workflow_sessions: '/workflow/get_workflow_sessions',
  create_workflow_session: '/workflow/create_workflow_session',
  update_workflow_session: '/workflow/update_workflow_session',
  get_workflow_session_details: '/workflow/get_workflow_session_details',
  lead_2_workflow_field: '/workflow/lead_2_workflow_field',

  users_current_location: '/ws/users_current_location',
  list_employee_meeting_routes: '/monitoring/list_employee_meeting_routes',
  emp_location_bulk_data: '/monitoring/emp_location_bulk_data',
  check_movement_status: '/monitoring/check_movement_status',
  geographical_get_branches: '/geographical/get_branches',

  get_gl_accounts: '/accounting/get_gl_accounts',
  add_or_update_gl_account: '/accounting/add_or_update_gl_account',
  product_charges_and_fee: '/accounting/product_charges_and_fee',
  subscribe_or_unsubscribe_gl_accounts: '/accounting/subscribe_or_unsubscribe_gl_accounts',
  get_party_gl_accounts: '/accounting/get_party_gl_accounts',
};

export {
  BASE_URL,
  AUTH_BASE_URL,
  SURVEY_BASE_URL,
  CORE_BASE_URL,
  SOURCING_BASE_URL,
  PRODUCTS_BASE_URL,
  LOAN_APP_BASE_URL,
  FFM_BASE_URL,
  HRMS_BASE_URL,
  ACCOUNTING_BASE_URL,
  ApiRoutes,
};

export * from './pagination.constants';
export * from './ui.constants';
export * from './accounting.constants';
export * from './lead.constants';
export * from './workflowField.constants';
export * from './workflowFormula.constants';
export * from './productConfig.constants';
export * from './feature.constants';
export * from './workflowSession.constants';
export * from './employee.constants';
export * from './geo.constants';
export * from './map.constants';
export * from './mapOrgDivisions.constants';
export * from './websocket.constants';
export * from './fieldMovement.constants';
export * from './loanApplication.constants';
export * from './dashboardHome.constants';
export * from './segmentGroup.constants';
export * from './workflowStage.constants';
export * from './workflowElementProperty.constants';
export * from './workflowElementUiProperties.constants';
export * from './workflowWidget.constants';
export * from './crudPage.constants';
export * from './organization.constants';
export * from './orgDivisionList.constants';
export * from './login.constants';
export * from './content.constants';
export * from './emi.constants';
export * from './build.constants';
